import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const updateDigitalTwinApi = async (data: any): Promise<any> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/recalculate`, data);
    return response.data;
  } catch (error) {
    console.error("Error recalculating vessel data:", error);
    throw error;
  }
};
